// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatar_avatar__158Pl","large":"UserAvatar_large__O3Byd","textAvatarContainer":"UserAvatar_textAvatarContainer__2T_eY"};